<div class="panel-content"
    [ngClass]="classes"
    [class.with-border]="withBorder">
    <ng-content></ng-content>
</div>
